/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiChangepasswordMutationRequest,
  PostApiChangepasswordMutationResponse,
} from '../models/PostApiChangepassword.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiChangepasswordMutationResponseSchema,
  postApiChangepasswordMutationRequestSchema,
} from '../zod/postApiChangepasswordSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiChangepasswordMutationKey = () =>
  [{ url: '/api/changePassword' }] as const;

export type PostApiChangepasswordMutationKey = ReturnType<
  typeof postApiChangepasswordMutationKey
>;

/**
 * {@link /api/changePassword}
 */
export async function postApiChangepassword(
  data: PostApiChangepasswordMutationRequest,
  config: Partial<RequestConfig<PostApiChangepasswordMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiChangepasswordMutationRequestSchema.parse(data);
  const res = await request<
    PostApiChangepasswordMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiChangepasswordMutationRequest
  >({
    method: 'POST',
    url: `/api/changePassword`,
    data: requestData,
    ...requestConfig,
  });
  return postApiChangepasswordMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/changePassword}
 */
export function usePostApiChangepassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiChangepasswordMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiChangepasswordMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiChangepasswordMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiChangepasswordMutationKey();

  return useMutation<
    PostApiChangepasswordMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiChangepasswordMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiChangepassword(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
